<div class="container ">
    <div class="row justify-content-center">
        <div class="col-md-11">
            <div class="hero_content">
                <div class="hero-header">
                    <div class="row justify-content-between">
                        <div class="col-md-4">
                            <div [ngClass]="{'addOpacity': myTarget < 98}">
                                <h2 class="text-uppercase">
                                    <span>CAT 2025</span> Course <span style="font-size: 14px;"
                                        class="d-flex align-items-center justify-content-center d-sm-none">Package
                                        Maker</span>
                                </h2>
                                <h6 class="d-none d-sm-block">Package Maker</h6>
                            </div>
                        </div>

                        <div class="col-md-7">

                            <div class="stepper-course-package">
                                <div class="stepper-header d-flex justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <img width="20" height="20"
                                            ngSrc="https://media.iquanta.in/ui_images/target.webp" alt="CAT Coaching">
                                        <p class="mb-0 text-uppercase">Set your target <span>percentile</span></p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <img width="20" height="20"
                                            ngSrc="https://media.iquanta.in/ui_images/group-people.webp"
                                            alt="CAT Coaching">
                                        <p class="mb-0 text-uppercase small-text">Last year <span>500+</span> students
                                            got
                                            <span>99+%ile</span>
                                        </p>
                                    </div>
                                </div>
                                <div id="slider-div" [class.fixed]="isFixed">
                                    <ngx-slider (mouseup)="setTarget($event)" [(value)]="myTarget"
                                        [options]="options"></ngx-slider>
                                </div>

                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
        <div class="col-md-12 d-none d-sm-block">

            <div class="hero_image position-relative" [ngClass]="{'addOpacity': myTarget < 98}">
                <div class="course-package-left">

                    <div class="curvide-lines">
                        <div class="img-dv">
                            <img width="69" height="142"
                                ngSrc="https://media.iquanta.in/ui_images/new-home/line-01.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>400+ Live</span> Classes</h4>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="curvide-lines curvide-lines1">
                        <div class="img-dv img-dv1">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-05.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>24*7</span> Doubt Solving</h4>
                            </div>
                        </div>
                    </div> -->


                    <div class="curvide-lines curvide-lines3">
                        <div class="img-dv img-dv3">
                            <img width="174" height="109"
                                ngSrc="https://media.iquanta.in/ui_images/new-home/line-04.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>24*7</span> Doubt Solving</h4>
                                <!-- <h4><span>2 Month Crash Course</span><br> included worth ₹19,499</h4> -->
                            </div>
                        </div>
                    </div>


                    <div class="position-cards">

                        <div class="single-card-element" [ngClass]="{'check-active': addonListIds.includes('403')}">
                            <p>CAT<br> Books </p>
                            <span>Latest Material</span>
                            <div (click)="addon('403', '')" class="dot">
                                <i *ngIf="addonListIds.includes('403')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img position-absolute">
                                <img width="160" height="88"
                                    ngSrc="https://media.iquanta.in/ui_images/new-home/hover-Books.webp"
                                    alt="CAT Books">
                            </div>

                            <div class="product_price">₹5,499</div>
                        </div>

                        <div class="single-card-element se-03 check-active">
                            <p>CAT Crash Course </p>
                            <span>2 Month</span>
                            <div class="dot">
                                <i class="bi bi-check-circle-fill"></i>
                            </div>
                            <!-- <div class="hover-img position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-Books.webp">
                            </div> -->

                            <div class="product_price ">Worth ₹19,499</div>
                        </div>

                        <div class="single-card-element se-02"
                            [ngClass]="{'check-active': addonListIds.includes('316')}">
                            <p>Non CAT<br>
                                Exams </p>
                            <span>Other Management
                                Exams Full Course</span>
                            <div (click)="addon('316', '')" class="dot">
                                <i *ngIf="addonListIds.includes('316')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img position-absolute">
                                <img width="160" height="88"
                                    ngSrc="https://media.iquanta.in/ui_images/new-home/hover-non-cat.webp"
                                    alt="Other Management Exams Full Course">
                            </div>
                            <div class="product_price">₹19,499</div>

                        </div>

                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="376" height="311" viewBox="0 0 376 311" fill="none">

                        <path *ngIf="!addonListIds.includes('403')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 142.058 290.791 121.025L240.709 63.256C222.475 42.2231 196.009 30.1405 168.173 30.1405H41"
                            stroke="url(#paint0_linear_2066_24412)" stroke-width="20" />

                        <path d="M375.5 154.14 H41" stroke="url(#paint00_linear_2066_24412)" stroke-width="20"
                            fill="none" />

                        <path *ngIf="addonListIds.includes('403')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 142.058 290.791 121.025L240.709 63.256C222.475 42.2231 196.009 30.1405 168.173 30.1405H41"
                            stroke="url(#paint00_linear_2066_24412)" stroke-width="20" />


                        <path *ngIf="!addonListIds.includes('316')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 166.223 290.791 187.256L240.709 245.025C222.475 266.058 196.009 278.14 168.173 278.14H41"
                            stroke="url(#paint1_linear_2066_24412)" stroke-width="20" />

                        <path *ngIf="addonListIds.includes('316')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 166.223 290.791 187.256L240.709 245.025C222.475 266.058 196.009 278.14 168.173 278.14H41"
                            stroke="url(#paint10_linear_2066_24412)" stroke-width="20" />


                        <defs>
                            <linearGradient id="paint0_linear_2066_24412" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="0" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint00_linear_2066_24412" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="0" />
                                <stop offset="1" stop-color="#128233" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint1_linear_2066_24412" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="0" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint10_linear_2066_24412" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="0" />
                                <stop offset="1" stop-color="#128233" stop-opacity="10" />
                            </linearGradient>

                        </defs>
                    </svg>
                </div>
                <div class="course-package-right">

                    <div class="curvide-lines curvide-lines2">
                        <div class="img-dv img-dv2">
                            <img width="75" height="89" ngSrc="https://media.iquanta.in/ui_images/new-home/line-02.webp"
                                alt="CAT Coaching">
                            <div class="img-text">
                                <h4><span>Exclusive Material</span> </h4>
                                <h5>Non engs. QA </h5>
                                <h5>engs. varc </h5>
                                <h5>lrdi inception </h5>
                                <h5>lrdi essential </h5>
                                <h5>varc essentials </h5>
                            </div>
                        </div>
                    </div>

                    <div class="curvide-lines curvide-lines4">
                        <div class="img-dv img-dv4">
                            <img width="105" height="4" ngSrc="https://media.iquanta.in/ui_images/new-home/line-05.webp"
                                alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>Daily Application</span> Classes</h4>
                                <p>iQuanta’s Unique way of teaching <br>
                                    where mentors help you solve questions <br>
                                    covered in Live classes along with <br>instant doubt solving.</p>
                            </div>
                        </div>
                    </div>


                    <div class="curvide-lines curvide-lines5">
                        <div class="img-dv img-dv5">
                            <img width="203" height="127"
                                ngSrc="https://media.iquanta.in/ui_images/new-home/line-04.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4><span>1000+</span> Assignments</h4>
                            </div>
                        </div>
                    </div>

                    <div class="position-cards">
                        <div class="single-card-element se-right check-active">
                            <div class="product_price pp-1">Worth ₹5,499</div>

                            <p>CAT<br> Mocks </p>
                            <span>AI Powered</span>
                            <div class="dot">
                                <i class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img1 position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-cat-mocks.webp"
                                    alt="CAT Mocks">
                            </div>

                        </div>
                        <div class="single-card-element se-right se-02"
                            [ngClass]="{'check-active': addonListIds.includes('439')}">
                            <p>IIM ABC Batch </p>
                            <span>7500 CAT Level Qs.</span>
                            <div (click)="addon('439', '')" class="dot">
                                <i *ngIf="addonListIds.includes('439')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img1 bg-white position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-iim-abc.webp"
                                    alt="IIM ABC Batch">
                            </div>
                            <div class="product_price">₹5,499</div>

                        </div>
                    </div>

                    <svg class="d-none d-sm-block" xmlns="http://www.w3.org/2000/svg" width="376" height="296"
                        viewBox="0 0 376 296" fill="none">


                        <path
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 133.058 84.709 112.025L134.791 54.256C153.025 33.2231 179.491 21.1405 207.327 21.1405H334.5"
                            stroke="url(#paint001_linear_2066_24402)" stroke-width="20" />

                        <path *ngIf="!addonListIds.includes('439')"
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 157.223 84.709 178.256L134.791 236.025C153.025 257.058 179.491 269.14 207.327 269.14H334.5"
                            stroke="url(#paint11_linear_2066_24402)" stroke-width="20" />

                        <path *ngIf="addonListIds.includes('439')"
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 157.223 84.709 178.256L134.791 236.025C153.025 257.058 179.491 269.14 207.327 269.14H334.5"
                            stroke="url(#paint111_linear_2066_24402)" stroke-width="20" />



                        <defs>


                            <linearGradient id="paint001_linear_2066_24402" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="10" />
                                <stop offset="1" stop-color="#128233" stop-opacity="0" />
                            </linearGradient>

                            <linearGradient id="paint11_linear_2066_24402" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="10" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="0" />
                            </linearGradient>

                            <linearGradient id="paint111_linear_2066_24402" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="10" />
                                <stop offset="1" stop-color="#128233" stop-opacity="0" />
                            </linearGradient>

                        </defs>
                    </svg>
                </div>

                <div class="hero_img-phone">
                    <div class="hero_img-phone-plug-right w-embed">
                        <img src="https://media.iquanta.in/ui_images/new-home/right-plug.svg" alt="Right Plug">
                    </div>
                    <div class="hero_img-phone-plug-left w-embed">
                        <img src="https://media.iquanta.in/ui_images/new-home/left-plug.svg" alt="Left Plug">
                    </div>
                    <img width="338" loading="eager" alt="CAT Coaching" class="hero_img-phone-frame"
                        src="https://media.iquanta.in/ui_images/mobile-video-bg.webp">

                    <div class="mobile-scrollable-content">

                        <div class="mobile-scrollable-content-inside">

                            <div class="video-mobile-in" *ngIf="!playVideoFlag"
                                (click)="playVideoFlag = !playVideoFlag">
                                <img width="364" loading="eager" alt="CAT 2025 Course" class="hero_img-phone-screenshot"
                                    [src]="thumbnail?.replace('s3-ap-south-1.amazonaws.com/iquantamedia', 'media.iquanta.in')">
                            </div>
                            <ng-container *ngIf="playVideoFlag">
                                <iframe loading="lazy" [src]="videoLinkMain" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen=""></iframe>
                            </ng-container>

                            <div class="content">
                                <div class="inside-box-mobile d-flex justify-content-between align-items-center">
                                    <div>
                                        <h2 class="f-bold">CAT 2025 New Batch</h2>
                                        <h6>Flagship Full Course</h6>
                                    </div>
                                    <div class="text-right rating">
                                        <p>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                        </p>
                                        <span class="rating-text f-medium">41894 Reviews</span>
                                    </div>

                                </div>

                                <div class="contest-list-card">
                                    <p [innerHTML]="productDetails?.description.slice(0, descCount) | safeHtml"></p>
                                    <button *ngIf="descCount < productDetails?.description.length" class="btn seemore" (click)="seeMore()">See More</button>
                                </div>

                            </div>
                        </div>

                    </div>


                    <div class="course-buying-card d-sm-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center pl-3">
                            <h2 class="mb-0">{{totalAmount|currency}}</h2>
                            <span class="ml-2"><del>{{priceObj?.actual_price|currency}}</del></span>
                        </div>
                        <button (click)="buynow()" class="btn buy_now">Buy Now</button>
                    </div>



                </div>

                <div class="extra-btns extra-btns-left d-sm-flex justify-content-between align-items-center">
                    <button (click)="gotosection('why_iquanta_is_best')" class="pushable pushone">
                        <div class="front">iQuanta Features</div>
                    </button>
                    <button (click)="gotosection('feedback')" class="pushable pushtwo">
                        <div class="front">iQuanta Toppers & Results</div>
                    </button>
                </div>

                <div class="extra-btns extra-btns-right d-sm-flex justify-content-between align-items-center">
                    <button (click)="openLeadForm()" class="pushable pushthree">
                        <div class="front"> Still Confused? Talk to a CAT Counsellor </div>
                    </button>
                </div>

            </div>
        </div>

        <div class="col-md-12  d-block d-sm-none">

            <div #sectionRef class="pb-5" id="sectionRef" [ngClass]="{'addOpacity': myTarget < 98}">
                <div #startSentinel class="sentinel"></div>
                <div class="add-ons-wrapper">
                    <div class="hero_image position-relative">
                        <div class="hero_img-phone">
                            <div class="hero_img-phone-plug-right w-embed">
                                <img src="https://media.iquanta.in/ui_images/new-home/right-plug.svg" alt="Right Plug">
                            </div>

                            <div class="hero_img-phone-plug-left w-embed">
                                <img src="https://media.iquanta.in/ui_images/new-home/left-plug.svg" alt="Left Plug">
                            </div>
                            <img width="338" loading="eager" alt="CAT Coaching" class="hero_img-phone-frame"
                                src="https://media.iquanta.in/ui_images/mobile-video-bg-new.webp">

                            <div class="mobile-scrollable-content">

                                <div class="mobile-scrollable-content-inside">

                                    <div class="video-mobile-in" *ngIf="!playVideoFlag"
                                        (click)="playVideoFlag = !playVideoFlag">
                                        <img width="364" loading="eager" alt="CAT 2025 Course"
                                            class="hero_img-phone-screenshot" [src]="thumbnail?.replace('s3-ap-south-1.amazonaws.com/iquantamedia', 'media.iquanta.in')">
                                    </div>
                                    <ng-container *ngIf="playVideoFlag">
                                        <iframe loading="lazy" [src]="videoLinkMain" frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen=""></iframe>
                                    </ng-container>

                                    <div class="content">
                                        <div
                                            class="inside-box-mobile d-flex justify-content-between align-items-center">
                                            <div>
                                                <h2 class="f-bold">CAT 2025 New Batch</h2>
                                                <h6>Flagship Full Course</h6>
                                            </div>
                                            <div class="text-right rating">
                                                <p>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                </p>
                                                <span class="rating-text f-medium">41894 Reviews</span>
                                            </div>

                                        </div>

                                        <div class="contest-list-card">
                                            <p [innerHTML]="productDetails?.description.slice(0, descCount) | safeHtml"></p>
                                    <button *ngIf="descCount < productDetails?.description.length" class="btn seemore" (click)="seeMore()">See More</button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="line-mobile-left"></div>
                    <div class="line-mobile-left left2"></div>
                    <div class="line-mobile-left right"></div>
                    <div class="line-mobile-left right right2"></div>


                    <div class="mobile-add-ons">

                        <div class="row">
                            <div class="col-6">
                                <div class="single-card-element"
                                    [ngClass]="{'check-active': addonListIds.includes('403')}">
                                    <p>CAT<br> Books </p>
                                    <span>Latest Material</span>
                                    <div (click)="addon('403', '')" class="dot">
                                        <i class="bi bi-check-circle-fill"></i>
                                    </div>
                                    <div class="product_price">₹5,499</div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-02"
                                    [ngClass]="{'check-active': addonListIds.includes('316')}">
                                    <p>Non CAT<br>
                                        Exams </p>
                                    <span>Other Management
                                        Exams Full Course</span>
                                    <div (click)="addon('316', '')" class="dot">
                                        <i class="bi bi-check-circle-fill"></i>
                                    </div>
                                    <div class="product_price">₹19,499</div>

                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-right check-active">
                                    <div class="product_price pp-1">Worth ₹5,499</div>

                                    <p>CAT<br> Mocks </p>
                                    <span>AI Powered</span>
                                    <div class="dot">
                                        <i class="bi bi-check-circle-fill"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-right se-02"
                                    [ngClass]="{'check-active': addonListIds.includes('439')}">
                                    <p>IIM ABC Batch </p>
                                    <span>7500 CAT Level Qs.</span>
                                    <div (click)="addon('439', '')" class="dot">
                                        <i class="bi bi-check-circle-fill"></i>
                                    </div>

                                    <div class="product_price">₹5,499</div>

                                </div>
                            </div>

                        </div>
                    </div>




                </div>
                <div class="incl-features" id="incl-features">
                    <div class="row">
                        <div class="col-12">
                            <div class="single-card-element se-03 check-active">
                                <p>CAT Crash Course </p>
                                <span>2 Month</span>
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div>

                                <div class="product_price ">Worth ₹19,499</div>
                            </div>
                        </div>
                    </div>
                    <div class="curvide-lines curvide-lines1">
                        <div class="img-text">
                            <h4 class="d-flex align-items-center justify-content-center">
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div> <span>24*7</span> Doubt Solving
                            </h4>
                        </div>
                    </div>

                    <div class="curvide-lines">
                        <div class="img-text">
                            <h4 class="d-flex align-items-center justify-content-center">
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div> <span>400+ Live</span> Classes
                            </h4>
                        </div>
                    </div>


                    <div class="curvide-lines curvide-lines5">
                        <div class="img-text">
                            <h4 class="d-flex align-items-center justify-content-center">
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div> <span>1000+</span> Assignments
                            </h4>
                        </div>
                    </div>
                    <div class="curvide-lines curvide-lines2">
                        <div class="img-text">
                            <h4 class="d-flex align-items-center justify-content-center">
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div> <span>Exclusive Material</span>
                            </h4>
                            <h5>Non engs. QA </h5>
                            <h5>engs. varc </h5>
                            <h5>lrdi inception </h5>
                            <h5>lrdi essential </h5>
                            <h5>varc essentials </h5>
                        </div>
                    </div>

                    <div class="curvide-lines curvide-lines4">
                        <div class="img-text">
                            <h4 class="d-flex align-items-center justify-content-center">
                                <div class="dot">
                                    <i class="bi bi-check-circle-fill"></i>
                                </div> <span>Daily Application</span> Classes
                            </h4>
                            <p>iQuanta’s Unique way of teaching <br>
                                where mentors help you solve questions <br>
                                covered in Live classes along with <br>instant doubt solving.</p>
                        </div>
                    </div>



                </div>

                <div class="ft-btn mt-4 mx-3">
                    <div class="extra-btns extra-btns-left d-flex justify-content-between align-items-center">
                        <button (click)="gotosection('why_iquanta_is_best')" class="pushable pushone">
                            <div class="front">iQuanta Features</div>
                        </button>
                        <button (click)="gotosection('feedback')" class="pushable pushtwo mr-0">
                            <div class="front">iQuanta Toppers & Results</div>
                        </button>
                    </div>

                    <div class="extra-btns extra-btns-right mt-3 d-sm-flex justify-content-between align-items-center">
                        <button (click)="openLeadForm()" class="pushable pushthree">
                            <div class="front"> Still Confused? Talk to a CAT Counsellor </div>
                        </button>
                    </div>
                </div>

                <div #stickyFooter [class.fixed]="isFixed"
                    class="sticky-footer course-buying-card d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center pl-3">
                        <h2 class="mb-0">{{totalAmount|currency}}</h2>
                        <span class="ml-2"><del>{{productDetails?.actual_price|currency}}</del></span>
                    </div>
                    <!-- <div class="coupon-tag d-flex flex-column  ml-auto">
                        <img src="https://media.iquanta.in/ui_images/coupon-tag.webp" alt="CAT Coaching">
                    </div> -->
                    <button (click)="buynow()" class="btn buy_now">Buy Now</button>

                </div>

                <div #endSentinel class="sentinel"></div>
            </div>

        </div>

    </div>
</div>